<template>
	<b-form @submit.stop.prevent="submitNewPassword" v-if="code" :busy="loading > 0">
		<b-form-group label="New password">
			<b-form-input
				v-model="passwordForm.password"
				type="password"
				placeholder="Enter new password"
				required
			></b-form-input>
		</b-form-group>
		<b-form-group label="Repeat new password">
			<b-form-input
				v-model="passwordForm.password2"
				type="password"
				placeholder="Enter new password again"
				required
			></b-form-input>
		</b-form-group>
		<b-alert variant="danger" v-show="error" show class="mb-0">{{error}}</b-alert>
		<b-row>
			<b-col cols="2">
				<b-spinner v-show="loading" small label="Loading"></b-spinner>
			</b-col>
			<b-col class="text-right">
				<router-link to="/">Return to login</router-link>
				<b-button size="sm" variant="success" type="submit" class="ml-3">Set new password</b-button>
			</b-col>
		</b-row>
	</b-form>
	<b-form @submit.stop.prevent="submitRecover" v-else :busy="loading > 0">
		<b-form-group id="login-email-group" label="Email address:" label-for="login-email">
			<b-form-input
				id="login-email"
				v-model="recoveryForm.email"
				type="text"
				placeholder="Enter your email address"
				required
			></b-form-input>
		</b-form-group>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<b-row>
			<b-col cols="2">
				<b-spinner v-show="loading" small label="Loading"></b-spinner>
			</b-col>
			<b-col class="text-right">
				<router-link to="/">Return to login</router-link>
				<b-button size="sm" variant="success" type="submit" class="ml-3">Reset password</b-button>
			</b-col>
		</b-row>
	</b-form>
</template>

<script>
export default {
	data() { return {
		loading: 0,
		error: null,
		code: null,
		recoveryForm: {
			email: '',
		},
		passwordForm: {
			password: '',
			password2: '',
		},
	}},
	created() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		this.code = params.code;
	},
	async mounted() {
		try {
			this.loading++;
			await this.$recaptcha.getRecaptcha()
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	async beforeDestroy() {
		await this.$recaptcha.cleanup();
	},
	methods: {
		async submitRecover() {
			try {
				this.loading++;
				this.error = this.message = null;
				await this.$api.post('recover', {
					...this.recoveryForm,
					recaptcha_token: await this.$recaptcha.execute('recover'),
				});
				this.$bvToast.toast('Please check your inbox for the password recovery link.', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				this.recoveryForm.email = '';
			} catch(err) {
				console.error(err);
				this.error = err;
			} finally {
				this.loading--;
			}

			return false;
		},
		async submitNewPassword() {
			try {
				this.loading++;
				this.error = this.message = null;
				await this.$api.post('user/passwordForCode', { code: this.code, ...this.passwordForm });
				this.$bvToast.toast('Password was changed. Redirecting you to login...', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				setTimeout(() => this.$router.push('/app'), 3000);
				this.recoveryForm.email = '';
			} catch(err) {
				console.error(err);
				this.error = err;
			} finally {
				this.loading--;
			}

			return false;
		},
	},
}
</script>
